import { defineMessages } from 'react-intl';

export const messages: {
	eventLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	eventLabel: {
		id: 'search-graph-customer-contact.customer-contact-label',
		defaultMessage: 'Customer Contact',
		description: 'Customer Contact subtype label',
	},
});
